import { type ComponentType } from "react";
import { type RouteObject } from "react-router";

import {
  AppBaseView,
  AppFrame,
  Landing,
  Locations,
  Login,
  PageNotFound,
  PlotMap,
  RootErrorBoundary,
  UserAuthCheck,
  UserProvider,
  Users,
} from "components";
import { appPages, type AppPage } from "defs";

// A new array each call. React Router writes on the objects you give it, so a
// shared array cannot be mounted by more than one router.
export const createAppRoutes = (): RouteObject[] => {
  // Defining the components in defs/app.ts results in circular import issues
  const pageComponents: Record<
    AppPage,
    {
      children?: RouteObject[];
      Component?: ComponentType;
      loader?: RouteObject["loader"];
    }
  > = {
    "": { Component: Landing },
    locations: { Component: Locations },
    map: { Component: PlotMap },
    users: { Component: Users },
  };

  return [
    {
      // Not using a loader because errors are the trigger to redirect to
      // the login page, and it's easier to track the different states
      // with the orval hook in the provider directly.
      Component: UserProvider,
      children: [
        {
          Component: AppFrame,
          children: [
            {
              path: "login",
              Component: Login,
            },
            {
              Component: UserAuthCheck,
              children: [
                {
                  Component: AppBaseView,
                  children: [
                    ...Object.keys(appPages).map((path) => {
                      const props = pageComponents[path as AppPage];

                      return path
                        ? { path, ...props }
                        : ({ index: true, ...props } as RouteObject);
                    }),
                    { path: ":page", Component: PageNotFound },
                  ],
                },
              ],
            },
          ],
        },
      ],
      ErrorBoundary: RootErrorBoundary,
    },
  ];
};
